import React from "react";
import { CircleHelp } from "lucide-react";
import { Button, Image } from 'shared-portal-components-v2';

function AuthHeader() {
  return (
    <header className="border-b border-border bg-background/95 backdrop-blur supports-[backdrop-filter]:bg-background/60">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="flex justify-between items-center py-4">
            <Image
              src="/logos/PortalSIXcorrectlogo.webp"
              alt="PortalSIX"
              className="w-[160px] h-auto max-w-none object-contain"
            />

          <Button
            variant="tertiary"
            size="sm"
            className="text-muted-foreground hover:text-foreground"
            type="button"
            onClick={() => { window.open('https://support.six3ro.com', '_blank', 'noopener,noreferrer'); }}
          >
            <CircleHelp className="w-4 h-4" aria-hidden="true" />
            Help
          </Button>
        </div>
      </div>
    </header>
  );
}

export default AuthHeader;
